import { Injectable } from '@angular/core';
import { DateRangeInterval } from '@app/core/components/date-range/date-range.component';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class DoDataImpService {
    constructor(private datatask: DataTaskService) {}

    /**
     * Retrieves the dataimp object mathcing the given keyno.
     *
     * @datatask 3174
     * @datataskName sp_ws_p2_w_dodataimp_get
     * @param params the keyno of the dataimp to retrieve.
     * @returns promise containing the dataimp.
     */
    public async getDoDataImp(params: GetDoDataImpParams): Promise<DoDataImpGet> {
        return (await this.datatask.Post(3174, params))[0];
    }

    /**
     * Fills the given dataimp with data from the db.
     *
     * @datatask 3175
     * @datataskName sp_ws_p2_w_dodataimp_fill
     * @param params the dataimp to fill with data from db.
     * @returns promise containing errorcode and message.
     */
    public async fillFromDb(params: DoDataImpGet): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(3175, params))[0];
    }

    /**
     * Imports the given excel data to the data import.
     *
     * @datatask 3179
     * @datataskName sp_ws_p2_w_dodataimp_excel_import
     * @param params the data to import.
     * @returns promise containing result code and message.
     */
    public async importFromExcel(params: DoDataImpImportFromExcelParams): Promise<DoDataImpImportFromExcelResponse> {
        return (await this.datatask.Post(3179, params))[0];
    }
}

export interface GetDoDataImpParams {
    dataimp_keyno: `${number}` | number;
}

export interface DoDataImpGet {
    dataimp_keyno: `${number}`;
    reg_datetime: string;
    reg_by_portal_user_name: string;
    dataimp_name: string;
    table_name_destination: string;
    proc_name_fill: string;
    proc_name_import: string;
    url_excel_template: string;
    word_id: string;
    proc_name_grid: string;
    main_destination_table_name: string;
    p2_datatask_keyno_grid: `${number}`;
    view_id_grid: string;
    show_pricelist_id: '1' | '0';
    show_language_id: '1' | '0';
    show_prodgrp_id: '1' | '0';
    show_prodtype_no: '1' | '0';
    show_stockplace_id: '1' | '0';
    show_datefomtom: '1' | '0';
    show_searchtext: '1' | '0';
    pricelist_id: string;
    language_id: string;
    prodgrp_id: string;
    prodtype_no: string;
    stockplace_id: string;
    date_fom: string;
    date_tom: string;
    dateselector_index: DateRangeInterval;
    searchtext: string;
}

export interface DoDataImpImportFromExcelParams {
    headerdata: string;
    records: string;
    table_name_destination: string;
}

export interface DoDataImpImportFromExcelResponse {
    exec_resultcode: `${number}`;
    exec_message: string;
}
